import React from "react";
import { EditableFieldProps } from "./types";

const EditableField = ({
  editable,
  text,
  handleChange,
  itemId,
  nflId,
  playId,
  isCustomValue,
}: EditableFieldProps) => {
  return (
    <>
      {!editable ? (
        text
      ) : (
        <>
          <input
            type="text"
            maxLength={playId ? 4 : nflId ? 7 : undefined}
            style={
              playId
                ? text.length <= 1
                  ? { borderColor: "red" }
                  : {}
                : nflId
                ? text.length <= 4
                  ? { borderColor: "red" }
                  : {}
                : isCustomValue
                ? text.length === 0
                  ? { borderColor: "red" }
                  : {}
                : {}
            }
            value={text}
            onChange={(event) => handleChange(event, itemId)}
            className="text-truncate"
          />
        </>
      )}
    </>
  );
};

export default EditableField;
